// The front end's optional modules. Each has init({ router, extensions }), called before the app
// starts. Removing a module: delete its folder and its line here.
import wechat from './wechat';

export default [wechat];
